export const audioHover = {

    bind(el, binding, vnode) {
        let hoveraudio = new Audio('/static/button_hover.mp3')
        // let muted = this.$muted
        el.addEventListener('mouseenter', () => {
            var clone = hoveraudio.cloneNode(true)
            clone.volume = 0.3
            clone.play()
        }, () => {
            return false
        })
    }
}


// WEBPACK FOOTER //
// ./src/directives/audioHover.js